<style type="text/scss">
	@import "./style.scss";
</style>

<script>
	import './main.js'

	import menu_item from '../public/content/gallery/description.json';
	import imprint_item from '../public/content/imprint.json';
	import vita_item from '../public/content/vita.json';

	const handleClick = name => () => {
		handleArrowClicks(name);
	}

	const handleFooterClick = site => () => {
		handleFooter(site);
	}

	const removeBackground = (id) => {
		document.getElementById(id).classList.remove('active');
		document.getElementById(id).style.backgroundColor = 'initial';
	}

	const addBackground = (id) => {
		document.getElementById(id).classList.add('active');
		document.getElementById(id).style.backgroundColor = '#dcdcdc';
	}

	const handleArrowClicks = (name) => {
		removeBackground(content_name);
		content_name = name;
		addBackground(content_name);
		setContentSite();
		setContentDescription();
		removeBackground(active_site);
		active_site = 1;
		addBackground(active_site);
		setContentImage();
	}

	const handleFooter = (site) => {
		removeBackground(active_site);
		active_site = site;
		addBackground(active_site);
		setContentImage();
	}

	const handleArrows = name => () => {
		if(name === "arrow_left") {
			if(active_site > 1) {
				handleFooter(active_site - 1);
			}
		}
		else if(name === "arrow_right") {
			if(active_site < content_site) {
				handleFooter(active_site + 1);
			}
		}
		else if(name === "arrow_up") {
			if(content_name !== menu_item[0].name) {
				for(let i = 0; i < menu_item.length; i++) {
					if(menu_item[i].name === content_name) {
						handleArrowClicks(menu_item[i - 1].name)
						return;
					}
				}
			}
		}
		else if(name === "arrow_down") {
			if(content_name !== menu_item[menu_item.length - 1].name) {
				for(let i = 0; i < menu_item.length; i++) {
					if(menu_item[i].name === content_name) {
						handleArrowClicks(menu_item[i + 1].name)
						return;
					}
				}
			}
		}
	}

	const setContentSite = () => {
		if(content_name === "vita") {
			content_site = Object.values(vita_item.german).length;
			if(document.getElementById('footer_pagination')) {
				if(document.getElementById('footer_pagination').style.display === 'none') {
					document.getElementById('footer_pagination').style.display = 'flex'
				}
			}
		}
		else if(content_name === "imprint") {
			content_site = 1;
			document.getElementById('footer_pagination').style.display = 'none';
		}
		else {
			for(let i = 0; i < menu_item.length; i++) {
				if(menu_item[i].name === content_name) {
					content_site = menu_item[i].number;
				}
			}
			if(document.getElementById('footer_pagination')) {
				if(document.getElementById('footer_pagination').style.display === 'none') {
					document.getElementById('footer_pagination').style.display = 'flex'
				}
			}
		}
	}

	const setContentDescription = () => {
		content_description = "";
		for(let i = 0; i < menu_item.length; i++) {
			if(menu_item[i].name === content_name) {
				content_description = menu_item[i].name + ", " + menu_item[i].year + ", " + menu_item[i].type + ", " + menu_item[i].size;
			}
		}
	}

	const setContentImage = () => {
		for(let i = 0; i < menu_item.length; i++) {
			if(menu_item[i].name === content_name) {
				content_image = 'content/gallery/' + content_name + '/' + menu_item[i].img_name + '_' + active_site + '.jpg';
			}
		}
	}

	const handleHover = id => () => {
		if(document.getElementById(id).style.backgroundColor !== '#dcdcdc') {
			document.getElementById(id).style.backgroundColor = '#dcdcdc';
		}
	}

	const handleMouseOut = id => () => {
		if(!document.getElementById(id).classList.contains('active')) {
			document.getElementById(id).style.backgroundColor = 'transparent';
		}
	}

	const handleMenu = () => {
		document.getElementById('mobile_menu').style.display = 'flex';
		menuActive = true;
	}

	const handleClose = () => {
		document.getElementById('mobile_menu').style.display = 'none';
		menuActive = false;
	}

	const handleActive = () => {
		if(menuActive){
			window.addEventListener('click', function(e){
				if(!document.getElementById('mobile_menu').contains(e.target) && !document.getElementById('mobile_menu_button').contains(e.target)){
					handleClose();
				}
			})
		}
	}

	let menuActive = false;
	let content_name = menu_item[0].name;
	let content_image = 'content/gallery/' + menu_item[0].name + '/' + menu_item[0].name + '_1.jpg'
	let active_site = 1;
	let content_site;
	setContentSite();
	let content_description;
	setContentDescription();
</script>

<main>

	<div class="mobile_menu_button" id="mobile_menu_button">
		<span on:click={handleMenu}>menu</span>
	</div>

	<div class="mobile_menu" id="mobile_menu">
		<span on:click={handleClose}>close</span>
		<div class="menu_logo">
			<span>Andreas Geisler</span>
			<span>Fotografie</span>
		</div>
		{#each menu_item as {name}}
			<span on:click={handleClick(name)}>{name}</span>
		{/each}
		<div>
			<span on:click={handleClick('vita')}>vita / exhibitions</span>
			<span on:click={handleClick('imprint')}>imprint / contact</span>
		</div>
	</div>

	<!--Sidebar-->
	<div class="sidebar">
		<div class="sidebar_logo box">
			<span>Andreas Geisler</span>
			<span>Fotografie</span>
		</div>

		<div class="sidebar_navigation box">
			<span on:click={handleArrows('arrow_up')} id="arrow_up" on:mouseover={handleHover("arrow_up")} on:mouseout={handleMouseOut("arrow_up")}>&#8593;</span>
			{#each menu_item as {name}}
				<span on:click={handleClick(name)} id="{name}" on:mouseover={handleHover(name)} on:mouseout={handleMouseOut(name)}>{name}</span>
			{/each}
			<span on:click={handleArrows('arrow_down')} id="arrow_down" on:mouseover={handleHover('arrow_down')}
				  on:mouseout={handleMouseOut('arrow_down')}>&#8595;</span>
		</div>

		<div class="sidebar_footer box">
			<span on:click={handleClick('vita')} id="vita" on:mouseover={handleHover("vita")}
				  on:mouseout={handleMouseOut("vita")}>vita / exhibitions</span>
			<span on:click={handleClick('imprint')} id="imprint" on:mouseover={handleHover("imprint")} on:mouseout={handleMouseOut("imprint")}>imprint / contact</span>
		</div>
	</div>

	<div class="body" on:click={handleActive}>
		<!--Imprint-->
		{#if content_name === "imprint"}
			<div class="body_content">
				<div class="content_header box main_imprint">
					<span>Impressum</span>
					<span>Imprint</span>
				</div>

				<div class="content_main box main_imprint">

					<div class="main_german">
						<span>Kontakt:</span>
						<div class="imprint_address content_box">
							{#each Object.values(imprint_item.address) as address}
								<span>{address}</span>
							{/each}
							{#each Object.values(imprint_item.contact) as contact}
								<span>{contact}</span>
							{/each}
						</div>
						<div class="imprint_design content_box">
							<span>Gestaltung: {imprint_item.design.layout}</span>
							<span>{imprint_item.design.copyright}</span>
						</div>
					</div>

					<div class="main_english">
						<span>contact:</span>
						<div class="imprint_address content_box">
							{#each Object.values(imprint_item.address) as address}
								<span>{address}</span>
							{/each}
							{#each Object.values(imprint_item.contact) as contact}
								<span>{contact}</span>
							{/each}
						</div>
						<div class="imprint_design content_box">
							<span>design: {imprint_item.design.layout}</span>
							<span>{imprint_item.design.copyright}</span>
						</div>
					</div>

				</div>
			</div>

			<!--vita-->
		{:else if content_name === "vita"}
			<div class="body_content">
				<div class="content_header box main_vita">
					<span>{Object.keys(vita_item.german)[active_site - 1]}</span>
					<span>{Object.keys(vita_item.english)[active_site - 1]}</span>
				</div>

				<div class="content_main box main_vita">
					<table>
						{#each Object.values(vita_item.german)[active_site - 1] as biography, i}
							<tr>
								<td class="main_years">
									<span>{biography.year}</span>
								</td>
								<td class="main_german">
									{#each biography.text as text}
										<span>{text}</span>
									{/each}
								</td>
								<td class="main_english">
									{#each Object.values(vita_item.english)[active_site - 1][i].text as text}
										<span>{text}</span>
									{/each}
								</td>
							</tr>
						{/each}
					</table>
				</div>
			</div>

		{:else}
			<div class="body_content content_image">
				<img alt="photography" src="{content_image}">
			</div>
		{/if}

		<div class="body_footer box">
			<div class="footer_content">
				<span>{content_description}</span>
			</div>

			<div class="footer_pagination" id="footer_pagination">
				<span on:click={handleArrows('arrow_left')} id="arrow_left" on:mouseover={handleHover('arrow_left')}
					  on:mouseout={handleMouseOut('arrow_left')}>&#171;</span>
				{#each Array(content_site) as _, i}
					<span on:click={handleFooterClick(i + 1)} id="{i + 1}" on:mouseover={handleHover(i+1)}
						  on:mouseout={handleMouseOut(i+1)}>{i + 1}</span>
				{/each}
				<span on:click={handleArrows('arrow_right')} id="arrow_right" on:mouseover={handleHover('arrow_right')}
					  on:mouseout={handleMouseOut('arrow_right')}>&#187;</span>
			</div>
		</div>
	</div>
</main>